module.exports = __webpack_public_path__ + "static/media/cardbg.b9f4eda4.svg";